"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.default = void 0;
var _quizzes = require("./quizzes.js");
var _QuizBlock = _interopRequireDefault(require("../../factories/QuizBlock.js"));
var _constants = require("../../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var reducers = {};
function setQuizBlock(state, json) {
  var quizId = parseInt(json.relationships.quiz.data.id);
  var quizBlockId = json.id;
  var quizBlock = state.getIn([quizId, 'quiz_blocks', quizBlockId]);
  quizBlock = quizBlock ? _QuizBlock.default.update(quizBlock, json) : new _QuizBlock.default(json);
  return state.setIn([quizId, 'quiz_blocks', quizBlockId], quizBlock);
}
function setQuizBlocks(state, payload) {
  return payload.included.filter(function (record) {
    return record.type === 'quiz_block';
  }).reduce(setQuizBlock, state);
}
function setQuizBlockTime(state, payload) {
  var quizId = payload.quizId,
    seconds = payload.seconds;
  var quiz = state.get(payload.quizId);
  var currentBlock = quiz.getIn(['quiz_blocks']).find(function (b) {
    return b.get('position') === quiz.get('last_quiz_block_number');
  });
  if (quiz.get('board_exam_interface') === 'fred') {
    if (currentBlock.get('seconds_remaining') <= 0) {
      var blocksToGo = quiz.get('quiz_blocks').filter(function (qb) {
        return qb.get('position') > quiz.get('last_quiz_block_number');
      });
      var eligibleBlocks = blocksToGo.filter(function (qb) {
        return qb.get('seconds_remaining') > 0;
      });
      currentBlock = eligibleBlocks.toList().sortBy(function (qb) {
        return qb.get('position');
      }).first();
    }
  }
  var newTime = currentBlock.get('seconds_remaining') - seconds >= 0 ? currentBlock.get('seconds_remaining') - seconds : 0;
  currentBlock = currentBlock.set('seconds_remaining', newTime);
  return state.setIn([quizId, 'quiz_blocks', "".concat(currentBlock.get('id'))], currentBlock);
}
function setQuizBlocksTick(state, payload) {
  var quiz = state.get(payload.quizId);
  if (!!quiz.get('quiz_blocks') && quiz.get('quiz_blocks').size) {
    var currentBlock = quiz.getIn(['quiz_blocks']).find(function (b) {
      return b.get('position') === quiz.get('last_quiz_block_number');
    });
    if (currentBlock.get('question_ids').size && quiz.get('block_pool_seconds_remaining') === null) {
      return setQuizBlockTime(state, payload);
    }
    if (!currentBlock.get('question_ids').size && quiz.get('break_pool_seconds_remaining') === null) {
      return setQuizBlockTime(state, payload);
    }
  }
  return state;
}
reducers[_constants.QUIZ_TICK] = setQuizBlocksTick;
reducers[_constants.QUIZ_FETCHED_PERFORMANCE] = setQuizBlocks;
reducers[_constants.QUIZ_FETCHED_PRACTICE] = setQuizBlocks;
reducers[_constants.QUIZ_CREATED] = setQuizBlocks;
reducers[_constants.QUIZZES_FETCHED] = setQuizBlocks;
reducers[_constants.QUIZ_FETCHED_TAKE] = setQuizBlocks;
reducers[_constants.QUIZ_FETCHED_QUESTIONS] = setQuizBlocks;
var reducer = exports.reducer = _quizzes.stateHelper.createReducer(reducers);
var _default = exports.default = reducers;